import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn, CanActivateChildFn } from '@angular/router';
import { buildHubLoginUrlWithReturn, isHubRedirectActive } from '../../utils/hub-redirect';
import { StorageService, TokenStorageKey } from '../../services/storage/storage.service';
import { AuthService } from '../../services/auth.service';
import { readHubTokenFromUrl, stripHubTokenFromUrl } from '../../utils/hub-product-token';

export const canActivate: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const authService = inject(AuthService);
    const storage = inject(StorageService);

    if (typeof window !== 'undefined') {
        const tokenFromUrl = readHubTokenFromUrl(window.location.search);
        if (tokenFromUrl) {
            authService.applyHubTokenFromUrl(tokenFromUrl);
            window.history.replaceState(
                {},
                '',
                stripHubTokenFromUrl(window.location.pathname, window.location.search, window.location.hash),
            );
        }
    }

    const accessToken = storage.getLocal(TokenStorageKey.ACCESS_TOKEN);
    if (accessToken) {
        return true;
    }

    if (typeof window !== 'undefined' && isHubRedirectActive()) {
        const returnUrl = `${window.location.origin}${state.url}`;
        window.location.href = buildHubLoginUrlWithReturn(returnUrl);
    }

    return false;
};

export const LoginGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    canActivate(route, state);
